import { render, staticRenderFns } from "./TravelNotesList.vue?vue&type=template&id=32de9772&scoped=true"
import script from "./TravelNotesList.vue?vue&type=script&lang=js"
export * from "./TravelNotesList.vue?vue&type=script&lang=js"
import style0 from "./TravelNotesList.vue?vue&type=style&index=0&id=32de9772&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32de9772",
  null
  
)

export default component.exports